import $data from '../utils/data'
import _ from 'underscore'
import Main from '@/views/main.vue'
import Index from '@/views/index'
import Market from '@/views/market'
import User from '@/views/user'
// import recycle from '@/views/recycle'
import cases from '@/views/cases'
import skill from '@/views/skill'
import show from '@/views/show'
import usertag from '@/views/usertag'
import regard from '@/views/regard'


import { Tool, Auth, Config } from '@/views/system'
// 不作为Main组件的子页面展示的页面单独写，如下
export let loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录',
  },
  component: (resolve) => {
    require(['@/views/login.vue'], resolve)
  },
}

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
let _otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/index',
  component: Main,
  children: [{ path: 'index', title: '首页', name: 'index_index', component: Index.Index }],
}

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
let _appRouter = [
  {
    path: '/main',
    icon: 'md-speedometer',
    name: 'index',
    title: '平台概况',
    component: Main,
    children: [{ path: 'index', title: '首页', name: 'index_index', auth: '/admin/dashboard/main', component: Index.Index }],
  },
  {
    path: '/market',
    icon: 'md-help-buoy',
    name: 'market',
    title: '功能列表',
    component: Main,
    show: true,
    children: [{ path: 'main', title: '功能', name: 'market_main', auth: '/admin/market/index', component: Market.MarketMain }],
  },

  { path: '', name: 'blank', title: '', children: [{ path: '' }] }, // 空白条
  {
    path: '/cases',
    icon: 'md-briefcase',
    name: 'cases',
    title: '案例管理',
    component: Main,
    children: [
      {
        path: 'list', title: '案例列表', name: 'cases_list', auth: '/admin/case/lists', component: cases.casesList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建案例', show: false, name: 'cases_add', auth: '/admin/case/add', component: cases.casesEdit },
      { path: 'edit', title: '编辑案例', show: false, name: 'cases_edit', auth: '/admin/case/edit', component: cases.casesEdit },
    ],
  },
  {
    path: '/casescategory',
    icon: 'ios-basket',
    name: 'casescategory',
    title: '案例分类',
    show: false,
    component: Main,
    children: [
      {
        path: 'casescategorylist', title: '分类列表', name: 'casescategory_list', auth: '/admin/casecategory/lists', component: cases.casescategoryList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建分类', show: false, name: 'casescategory_add', auth: '/admin/casecategory/add', component: cases.casescategoryEdit },
      { path: 'edit', title: '编辑分类', show: false, name: 'casescategory_edit', auth: '/admin/casecategory/edit', component: cases.casescategoryEdit },
    ],
  },
  {
    path: '/skill',
    icon: 'ios-options',
    name: 'skill',
    title: '技术管理',
    component: Main,
    children: [
      {
        path: 'list', title: '技术列表', name: 'skill_list', auth: '/admin/skill/lists', component: skill.skillList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建技术', show: false, name: 'skill_add', auth: '/admin/skill/add', component: skill.skillEdit },
      { path: 'edit', title: '编辑技术', show: false, name: 'skill_edit', auth: '/admin/skill/edit', component: skill.skillEdit },
    ],
  },
  {
    path: '/skillcategory',
    icon: 'ios-basket',
    name: 'skillcategory',
    title: '技术分类',
    show: false,
    component: Main,
    children: [
      {
        path: 'skillcategorylist', title: '分类列表', name: 'skillcategory_list', auth: '/admin/skillcategory/lists', component: skill.skillcategoryList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建分类', show: false, name: 'skillcategory_add', auth: '/admin/skillcategory/add', component: skill.skillcategoryEdit },
      { path: 'edit', title: '编辑分类', show: false, name: 'skillcategory_edit', auth: '/admin/skillcategory/edit', component: skill.skillcategoryEdit },
    ],
  },
  {
    path: '/show',
    icon: 'ios-laptop',
    name: 'show',
    title: '展厅管理',
    component: Main,
    children: [
      {
        path: 'list', title: '展厅列表', name: 'show_list', auth: '/admin/show/lists', component: show.showList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建展厅', show: false, name: 'show_add', auth: '/admin/show/add', component: show.showEdit },
      { path: 'edit', title: '编辑展厅', show: false, name: 'show_edit', auth: '/admin/show/edit', component: show.showEdit },
    ],
  },
  {
    path: '/showcategory',
    icon: 'ios-basket',
    name: 'showcategory',
    title: '展厅分类',
    show: false,
    component: Main,
    children: [
      {
        path: 'showcategorylist', title: '分类列表', name: 'showcategory_list', auth: '/admin/showcategory/lists', component: show.showcategoryList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建分类', show: false, name: 'showcategory_add', auth: '/admin/showcategory/add', component: show.showcategoryEdit },
      { path: 'edit', title: '编辑分类', show: false, name: 'showcategory_edit', auth: '/admin/showcategory/edit', component: show.showcategoryEdit },
    ],
  },
  {
    path: '/usertag',
    icon: 'ios-bookmark',
    name: 'usertag',
    title: '标签管理',
    component: Main,
    children: [
      {
        path: 'list', title: '标签列表', name: 'usertag_list', auth: '/admin/usertag/lists', component: usertag.usertagList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建标签', show: false, name: 'usertag_add', auth: '/admin/usertag/add', component: usertag.usertagEdit },
      { path: 'edit', title: '编辑标签', show: false, name: 'usertag_edit', auth: '/admin/usertag/edit', component: usertag.usertagEdit },
      { path: 'edit', title: '编辑标签', show: false, name: 'usertag_edit', auth: '/admin/usertag/edit', component: usertag.usertagEdit },
    ],
  },
  {
    path: '/regard',
    icon: 'ios-list-box',
    name: 'regard',
    title: '关于我们',
    component: Main,
    children: [
      {
        path: 'list', title: '关于我们', name: 'regard_list', auth: '/admin/regard/lists', component: regard.regardList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建技术', show: false, name: 'regard_add', auth: '/admin/regard/add', component: regard.regardEdit },
      { path: 'edit', title: '编辑技术', show: false, name: 'regard_edit', auth: '/admin/regard/edit', component: regard.regardEdit },
    ],
  },
  // {
  //   path: '/recycle',
  //   icon: 'md-refresh-circle',
  //   name: 'recycle',
  //   title: '回收订单',
  //   component: Main,
  //   children: [
  //     { path: 'list', title: '订单列表', name: 'recycle_list', auth: '/admin/recycle/lists', component: recycle.recycleList },
  //   ],
  // },
  // {
  //   path: '/recyclecategory',
  //   icon: 'ios-basket',
  //   name: 'recyclecategory',
  //   title: '回收分类',
  //   show: false,
  //   component: Main,
  //   children: [
  //     { path: 'recyclecategorylist', title: '类型列表', name: 'recyclecategory_list', auth: '/admin/recyclecategory/lists', component: recycle.recyclecategoryList },
  //     { path: 'add', title: '创建分类', show: false, name: 'recyclecategory_add', auth: '/admin/recyclecategory/add', component: recycle.recyclecategoryEdit },
  //     { path: 'edit', title: '编辑分类', show: false, name: 'recyclecategory_edit', auth: '/admin/recyclecategory/edit', component: recycle.recyclecategoryEdit },
  //   ],
  // },
  {
    path: '/user',
    icon: 'md-person',
    name: 'user',
    title: '用户管理',
    component: Main,
    children: [
      {
        path: 'list', title: '用户列表', name: 'user_list', auth: '/admin/user/lists', component: User.UserList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      {
        path: 'record', title: '积分记录', show: false, name: 'record_list', auth: '/admin/record/lists', component: User.recordList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'add', title: '创建用户', show: false, name: 'user_add', auth: '/admin/user/add', component: User.UserEdit },
      { path: 'edit', title: '编辑用户', show: false, name: 'user_edit', auth: '/admin/user/edit', component: User.UserEdit },
    ],
  },
  {
    path: '/user/up',
    icon: 'md-person',
    name: 'user_up',
    title: '用户管理',
    component: Main,
    show: false,
    children: [{
      path: 'uppassword', title: '修改密码', show: false, name: 'user_up_password', auth: '', component: User.UserEditPassword, meta: {
        keepAlive: true  // 需要缓存
      }
    }],
  },
  // {
  //   path: '/analysis',
  //   icon: 'md-pie',
  //   name: 'analysis',
  //   title: '数据统计',
  //   component: Main,
  //   show: true,
  //   children: [{ path: 'list', title: '数据统计', name: 'analysis_index', auth: '/admin/analysis/index', component: Analysis.AnalysisIndex }],
  // },

  {
    path: '/auth',
    icon: 'md-lock',
    name: 'auth',
    title: '权限控制',
    component: Main,
    show: false,
    children: [
      {
        path: 'rule', title: '权限规则', name: 'auth_rule_list', auth: '/admin/authrule/lists', icon: 'ios-list-box', component: Auth.AuthRuleList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'rulemain', title: '权限规则', name: 'auth_rule_main', auth1: '/admin/authrule/main', icon: 'ios-list-box', component: Auth.AuthRuleMain },
      { path: 'add', title: '创建权限', show: false, name: 'auth_rule_add', auth: '/admin/authrule/add', icon: 'compose', component: Auth.AuthRuleEdit },
      { path: 'edit', title: '编辑权限', show: false, name: 'auth_rule_edit', auth: '/admin/authrule/edit', icon: 'compose', component: Auth.AuthRuleEdit },

      {
        path: 'group', title: '权限组', name: 'auth_group_list', auth: '/admin/authgroup/lists', icon: 'ios-list-box', component: Auth.AuthGroupList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'groupadd', title: '创建权限组', show: false, name: 'auth_group_add', auth: '/admin/authgroup/add', icon: 'compose', component: Auth.AuthGroupEdit },
      { path: 'groupedit', title: '编辑权限组', show: false, name: 'auth_group_edit', auth: '/admin/authgroup/edit', icon: 'compose', component: Auth.AuthGroupEdit },

      {
        path: 'access', title: '管理员', name: 'auth_access_list', auth: '/admin/authaccess/lists', icon: 'ios-list-box', component: Auth.AuthAccessList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'accessadd', title: '创建管理员', show: false, name: 'auth_access_add', auth: '/admin/authaccess/add', icon: 'compose', component: Auth.AuthAccessEdit },
      { path: 'accessedit', title: '编辑管理员', show: false, name: 'auth_access_edit', auth: '/admin/authaccess/edit', icon: 'compose', component: Auth.AuthAccessEdit },

      {
        path: 'type', title: '账户类型', show: false, name: 'auth_type_list', auth: '/admin/authtype/lists', component: Auth.AuthTypeList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      { path: 'typeadd', title: '创建账户类型', show: false, name: 'auth_type_add', auth: '/admin/authtype/add', component: Auth.AuthTypeEdit },
      { path: 'typeedit', title: '编辑账户类型', show: false, name: 'auth_type_edit', auth: '/admin/authtype/edit', component: Auth.AuthTypeEdit },
    ],
  },
  {
    path: '/tool',
    icon: 'md-tool',
    name: 'tool',
    title: '工具集合',
    component: Main,
    show: false,
    children: [
      {
        path: 'shorturl', title: '短链接', name: 'tool_shorturl_list', auth: '/admin/shorturl/lists', icon: 'arrow-graph-up-right', component: Tool.ShorturlList, meta: {
          keepAlive: true  // 需要缓存
        }
      },
      {
        path: 'upload', title: '上传文件', name: 'tool_upload_list', auth: '/admin/upload/lists', icon: 'ios-list-box', component: Tool.UploadList, meta: {
          keepAlive: true  // 需要缓存
        }
      },

      { path: 'shorturladd', title: '创建短链接', show: false, name: 'shorturl_add', component: Tool.ShorturlEdit },
      { path: 'shorturledit', title: '编辑短链接', show: false, name: 'shorturl_edit', component: Tool.ShorturlEdit },
    ],
  },
  {
    path: '/config',
    icon: 'md-cog',
    name: 'config',
    title: '系统配置',
    component: Main,
    show: true,
    children: [{ path: 'base', title: '基本配置', name: 'config_name', icon: 'arrow-graph-up-right', auth: '/admin/config/lists', component: Config.ConfigBase }],
  },
  // {
  //     path: '/error-page',
  //     icon: 'android-sad',
  //     title: '错误页面',
  //     name: 'errorpage',
  //     component: Main,
  //     children: [
  //         { path: 'index', title: '错误页面', name: 'errorpage_index', component: resolve => { require(['@/views/error/error-page.vue'], resolve); } },
  //     ]
  // }
]

// 不作为Main组件的子页面展示的页面单独写，如下
export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在',
  },
  component: (resolve) => {
    require(['@/views/error/404.vue'], resolve)
  },
}

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足',
  },
  name: 'error-403',
  component: (resolve) => {
    require(['@//views/error/403.vue'], resolve)
  },
}

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误',
  },
  name: 'error-500',
  component: (resolve) => {
    require(['@/views/error/500.vue'], resolve)
  },
}

export const locking = {
  path: '/locking',
  name: 'locking',
  component: (resolve) => {
    require(['@/views/components/main/lockscreen/components/locking-page.vue'], resolve)
  },
}

Array.prototype.remove = function (val) {
  if (isNaN(val) || val > this.length) {
    return false
  }
  for (var i = 0, n = 0; i < this.length; i++) {
    if (this[i] != this[val]) {
      this[n++] = this[i]
    }
  }
  this.length -= 1
}

// 通过用户权限筛选路由  !仅处理2层路由
// 用户权限表
function _doRules(arr) {
  const rules = $data.get('auth', 'auths')
  const arr_temp = []
  const tt = _.compact(arr)
  for (let i = 0; i < tt.length; i++) {
    const item = tt[i]
    // 设置标题
    item.meta = item.meta || {}
    item.meta.title = item.meta.title || item.title || ''
    // 判断子路由
    if (item.children && item.children.length > 0) {
      item.children = _doRules(item.children)
    }
    // 判断自身
    if (true && item.auth && _.findIndex(rules, { url: item.auth }) < 0) {
      // 拒绝， 去除路由
      // console.log(item.auth, -1)
    } else {
      // 添加
      arr_temp.push(item)
    }
  }
  return arr_temp
}
// 处理appRouter、otherRouter
_appRouter = _doRules(_appRouter)
_otherRouter.children = _doRules(_otherRouter.children)
export const appRouter = _appRouter
export const otherRouter = _otherRouter
// console.log('routexxxxxxxx appRouter', appRouter);
// console.log('routexxxxxxxx otherRouter', otherRouter);

// 所有上面定义的路由都要写在下面的routers里
export const routers = [loginRouter, otherRouter, locking, ...appRouter, page500, page403, page404]
